import React from "react";
import type { FC } from "react";

import { useSubscriptionEditState } from "./SubscriptionEditProvider.state";
import { SubscriptionEditProviderContext } from "./SubscriptionEditProvider.context";
import { ISubscriptionEditProviderProps } from "./SubscriptionEditProvider.types";

const SubscriptionEditProviderContextProvider = SubscriptionEditProviderContext.Provider;

const SubscriptionEditProvider: FC<ISubscriptionEditProviderProps> = (props) => {
  const { children } = props;

  const state = useSubscriptionEditState(props);

  return <SubscriptionEditProviderContextProvider value={state}>{children}</SubscriptionEditProviderContextProvider>;
};

export { SubscriptionEditProvider };
